export const PAYMENT_PLAN_CONFIRMED_PAYMENT_REQUESTING = 'PAYMENT_PLAN_CONFIRMED_PAYMENT_REQUESTING';
export const PAYMENT_PLAN_CONFIRMED_PAYMENT_SUCCESS = 'PAYMENT_PLAN_CONFIRMED_PAYMENT_SUCCESS';
export const PAYMENT_PLAN_CONFIRMED_PAYMENT_ERROR = 'PAYMENT_PLAN_CONFIRMED_PAYMENT_ERROR';

export const PAYMENT_PLAN_UPDATE_REQUESTING = "PAYMENT_PLAN_UPDATE_REQUESTING";
export const PAYMENT_PLAN_UPDATE_SUCCESS = "PAYMENT_PLAN_UPDATE_SUCCESS";
export const PAYMENT_PLAN_UPDATE_ERROR  = "PAYMENT_PLAN_UPDATE_ERROR";